<template>
  <div>
    <p class="decode-result">
      扫描结果: <b>{{ result }}</b>
    </p>
    <!--扫描结果-->

    <qrcode-stream @decode="onDecode" @init="onInit" />
  </div>
</template>

<script>
//下载插件
//cnpm install --save  vue-qrcode-reader

//引入
import { QrcodeStream } from "vue-qrcode-reader";
import api from "../../common/js/api";
export default {
  data() {
    return {
      result: "", //扫码结果信息
      type: this.$route.query.type,
      id: this.$route.query.id,
      openId: "",
    };
  },

  components: {
    QrcodeStream,
  },

  computed: {},

  created() {
    var openId = localStorage.getItem("openId");
    if (!openId) {
      this.$router.replace("/merchantBind");
    } else {
      this.openId = openId;
    }
  },

  mounted() {},

  methods: {
    onDecode(result) {
      if (this.type == "bindMeal") {
        this.result = this.getUrlKey(result, "voucherCode");
        this.$post(api.bindCard, {
          cardNo: this.result.trim(),
          optionsId: this.id,
        }).then((res) => {
          if (res.success) {
            this.$toast({ message: res.message, type: "success" });
          } else {
            this.$toast(res.message);
          }
        });
      } else if (this.type == "bindOrder") {
        this.result = result;
        this.$post(api.bindOrder, {
          openId: this.openId,
          id: this.id,
          expressNo: result,
        }).then((res) => {
          if (res.success) {
            let toast = this.$toast({ message: res.message, type: "success" });
            setTimeout(() => {
              toast.clear();
              this.$router.replace("/merchantBind");
            }, 1000);
          } else {
            this.$toast(res.message);
          }
        });
      } else {
        this.$router.replace("/merchantBind");
      }
    },

    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: 您需要授予相机访问权限";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: 这个设备上没有摄像头";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: 所需的安全上下文(HTTPS、本地主机)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: 相机被占用";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: 安装摄像头不合适";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: 此浏览器不支持流API";
        }
      }
    },
    getUrlKey(url, paraName) {
      var arrObj = url.split("?");

      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang='scss' scoped>
</style>